import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { Redirect, Route, withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import withEntries from '../../Contexts/Entries/WithEntries.context'
import withServices from '../../Contexts/Services/WithServices.context'
import authCurrentSelector from '../../State/Store/Users/Selectors/UserCurrent.selector'
import GlobalSnackbar from './parts/GlobalSnackbar'
import GlobalBanner from './parts/GlobalBanner'
import NotificationsModal from 'Components/NotificationsModal/NotificationsModal.component'
import AddToHomeScreen from 'Components/AddToHomeScreen/AddToHomeScreen.component'
import AddToHomeScreenAndroid from 'Components/AddToHomeScreenAndroid/AddToHomeScreenAndroid.component'

const PrivateRouteComponent = ({ history, render, auth, entry, services, ...rest }: any) => {
  return (
    <React.Fragment>
      <GlobalBanner />
      <GlobalSnackbar />
      <NotificationsModal />
      <AddToHomeScreen />
      <AddToHomeScreenAndroid />
      <Route
        {...rest}
        render={(props) => {
          return auth === null
            ? <Redirect to={{
              pathname: entry.postLogoutLink,
              state: { from: props.location },
            }} />
            : render(props)
        }}
      />
    </React.Fragment>
  )
}

const PrivateRoute = compose(
  withEntries,
  withServices,
  withRouter,
  connect((state) => ({
    auth: authCurrentSelector(state),
  })),
)(PrivateRouteComponent)

export default PrivateRoute
